import { FieldValue } from '@/components/registration/models/field';

export const stringifyFieldValue = (value: FieldValue): string => {
  return (value === null ? '' : value).toString();
};
